import type { GetShippingPolicyRequest } from './types';

export const SITECONFIG_QUERY_KEYS = {
  default: () => ['siteconfig'] as const,
  getShippingPolicies: () => [...SITECONFIG_QUERY_KEYS.default(), 'shippingPolicies'] as const,
  getShippingPolicy: (params: GetShippingPolicyRequest) =>
    [...SITECONFIG_QUERY_KEYS.default(), 'shippingPolicy', params.currency] as const,
};
